@if (patient) {
  <app-traitement-data-debit-min-max [patient]="patient!" />
  <app-traitement-data-duree-min-max [patient]="patient!" />
} @else {
  <app-traitement-data></app-traitement-data>
  <app-traitement-data></app-traitement-data>
}
